import React from 'react';
import { useTranslation } from '../../i18n';

interface WaitingSpinnerProps {
  message?: string;
  isLoading?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const WaitingSpinner: React.FC<WaitingSpinnerProps> = ({
  message,
  isLoading = false,
  size = 'small',
}) => {
  const { t } = useTranslation();

  const spinnerSizes = {
    small: { width: '32px', height: '32px', border: '3px' },
    medium: { width: '40px', height: '40px', border: '4px' },
    large: { width: '50px', height: '50px', border: '5px' },
  };

  const { width, height, border } = spinnerSizes[size];
  const defaultMessage = isLoading
    ? t('gameplay.loading.nextQuestion')
    : t('gameplay.loading.waitingForOthers');

  return (
    <div
      className="waiting-spinner"
      style={{
        textAlign: 'center',
        paddingTop: '1rem',
        marginTop: '2rem',
        marginBottom: '1rem',
      }}
    >
      <div
        className={`waiting-spinner__ring${isLoading ? '' : ' waiting-spinner__ring--waiting'}`}
        style={{
          display: 'inline-block',
          width,
          height,
          border: `${border} solid rgba(var(--color-primary-rgb), 0.15)`,
          borderTop: `${border} solid ${isLoading ? 'var(--color-primary)' : '#ca8a04'}`,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '0.5rem',
        }}
      />
      <p
        className={`waiting-spinner__text${isLoading ? ' waiting-spinner__text--loading' : ' waiting-spinner__text--waiting'}`}
        style={{
          color: isLoading ? 'var(--color-primary)' : '#ca8a04',
          fontSize: '1rem',
          fontWeight: 'bold',
          margin: 0,
        }}
      >
        {message || defaultMessage}
      </p>
    </div>
  );
};

export default WaitingSpinner;
